import {
  Create,
  TextInput,
  SaveButton,
  SimpleForm,
  Toolbar,
  useNotify,
  required,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { Paper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

const AvulsoSaveButton = (props) => {
  const notify = useNotify();
  const { reset } = useFormContext();

  const onError = () =>
    notify("Erro ao processar a transferência", {
      type: "error",
    });

  const onSuccess = (_) => {
    notify("Transferência feita com sucesso!", { type: "success" });
    reset();
  };

  return (
    <SaveButton
      {...props}
      type="button"
      label="Enviar"
      mutationOptions={{ onError, onSuccess }}
    />
  );
};

const AvulsoToolbar = (props) => (
  <Toolbar {...props}>
    <AvulsoSaveButton />
  </Toolbar>
);

const AvulsoSection = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<AvulsoToolbar />}>
      <Paper sx={{ width: "97%", padding: 2, margin: 2 }}>
        <Typography align="center" variant="h5" gutterBottom>
          Transação avulso
        </Typography>

        <ReferenceInput
          fullWidth
          source="identificador"
          reference="usuarios"
          label="Usuário"
          validate={[required()]}
          parse={(value) => value}
          format={(value) => value}
        >
          <AutocompleteInput optionText="email" />
        </ReferenceInput>

        <TextInput
          fullWidth
          label="Hash"
          source="hash"
          validate={[required()]}
        />
      </Paper>
    </SimpleForm>
  </Create>
);

export default AvulsoSection;
